var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "imageVideoGallery",
      class: {
        "is-grid-mode": _vm.layoutMode == "grid",
        "is-loading": _vm.loading,
        "is-modern": _vm.galleryVersion == "modern",
        "is-legacy": _vm.galleryVersion == "legacy",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "loading-icon",
          attrs: {
            "aria-label": "Loading",
            "aria-hidden": _vm.loading == false,
          },
        },
        [_c("div"), _c("div")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "group" }, [
        _c("div", { staticClass: "componentContainer" }, [
          _c(
            "div",
            {
              staticClass: "controls-container",
              class: {
                "controls-container--modern": _vm.galleryVersion == "modern",
              },
            },
            [
              _vm.galleryVersion == "legacy"
                ? [
                    _c(
                      "div",
                      { staticClass: "controls-container__inner" },
                      [
                        _vm.showFilterControls
                          ? _c("gallery-filter")
                          : _vm._e(),
                        _vm._v(" "),
                        _c("gallery-autoplay-toggle"),
                      ],
                      1
                    ),
                  ]
                : _vm.galleryVersion == "modern" && _vm.pageWidth >= 768
                ? [
                    _c("galleryLayoutModeToggle", {
                      staticClass: "controls-container__inner--modern",
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "controls-container__inner" },
                      [
                        _vm.showFilterControls
                          ? _c("gallery-filter")
                          : _vm._e(),
                        _vm._v(" "),
                        _c("gallery-autoplay-toggle"),
                      ],
                      1
                    ),
                  ]
                : _vm.galleryVersion == "modern" && _vm.pageWidth < 768
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "controls-container__inner controls-container__inner--modern mobile-show",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "controls-container__inner-top" },
                          [
                            _c("galleryLayoutModeToggle"),
                            _vm._v(" "),
                            _c("gallery-autoplay-toggle", {
                              staticClass: "controls-container__inner--modern",
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "controls-container__inner-bottom" },
                          [
                            _vm.showFilterControls
                              ? _c("gallery-filter")
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "componentContainer componentContainer--listing" },
          [_c("gallery-list")],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm.activeItem ? _c("gallery-modal") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }